import { Button } from 'system/atoms';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React from 'react';
import { useCopyToClipboard } from '@uidotdev/usehooks';
import CheckIcon from '@mui/icons-material/Check';

type Props = {
  copyText?: string;
  valuesToCopyFunction: () => string | undefined;
};

export const CopyButton: React.FC<Props> = ({
  copyText,
  valuesToCopyFunction
}) => {
  const [value, copyValue] = useCopyToClipboard();

  const handleCopyJobDetails = async () => {
    await copyValue(valuesToCopyFunction() || '');
  };

  return (
    <Button
      variant="tertiary"
      sx={{ color: value ? 'success.dark' : 'primary.main' }}
      startIcon={value ? <CheckIcon /> : <ContentCopyIcon />}
      onClick={handleCopyJobDetails}
    >
      {value ? 'Copied' : copyText || 'Copy'}
    </Button>
  );
};
